// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .add-engagement .p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container, .add-engagement .p-autocomplete{
    padding-left: 0;
    text-indent: 7px;
}

.w-100 {
    font-size: small;
    color: #646262;
}

.cancel:hover {
    background-color:#666 !important;
  }

  ::ng-deep .add-engagement .radiobtn label {
    position: relative;
    bottom: 0;
  }

  .hinttext1{
    font-size: 10px;
    color: #333;
    line-height: 0px;
    left: 5px;
    position: relative;
    bottom: 0;
  }

  .row {
    display: flex;
  }
  
`, "",{"version":3,"sources":["webpack://./src/app/features/engagement/add-edit/add-edit.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;EACf","sourcesContent":[":host ::ng-deep .add-engagement .p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container, .add-engagement .p-autocomplete{\r\n    padding-left: 0;\r\n    text-indent: 7px;\r\n}\r\n\r\n.w-100 {\r\n    font-size: small;\r\n    color: #646262;\r\n}\r\n\r\n.cancel:hover {\r\n    background-color:#666 !important;\r\n  }\r\n\r\n  ::ng-deep .add-engagement .radiobtn label {\r\n    position: relative;\r\n    bottom: 0;\r\n  }\r\n\r\n  .hinttext1{\r\n    font-size: 10px;\r\n    color: #333;\r\n    line-height: 0px;\r\n    left: 5px;\r\n    position: relative;\r\n    bottom: 0;\r\n  }\r\n\r\n  .row {\r\n    display: flex;\r\n  }\r\n  \r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
